// Import CSS
import "../css/index.css";
// Import JS
import handler from "./script";
// Call the handler on DOM loaded
if (document.readyState === 'complete' || (document.readyState !== 'loading' && !document.documentElement.doScroll)) {
    handler();
} else {
    document.addEventListener('DOMContentLoaded', handler);
}